( function( $, document, window ) {
	'use strict';

	$( function() {        
		const swiper = new Swiper('.js-testimonial-collection', {
			direction: 'horizontal',
			slidesPerView: 1.25,
			spaceBetween: 20,
			loop: true,
			grabCursor: true,
            centeredSlides: true,

            navigation: {
                prevEl: '.js-testimonial-collection-prev',
                nextEl: '.js-testimonial-collection-next',
            },

            breakpoints: {
                580: {
                    spaceBetween: 40,
                },
                1024: {
                    slidesPerView: 1.5,
                    spaceBetween: 60,
                }
            },

            on: {
				beforeInit: function() {
					let numSlides = this.wrapperEl.querySelectorAll( '.js-testimonial-item' ).length;
					if ( numSlides <= 3 ) {
						this.params.loop = false;
					}
				}
			}
		});
	} );
} )( jQuery, document, window );
